export default __webpack_public_path__ + "static/media/images.c6fe3310.png";